//#region src/utils/classNames.ts
var e = (...e) => e.filter(Boolean).join(" ");
//#endregion
export { e as default };

//# sourceMappingURL=classNames.js.map